import React from "react";
import PropTypes from "prop-types";
import DebouncedInput from "components/Common/DebouncedInput";
import Button from "components/Common/Button";
import colors from "stylesheets/utilities/colors.scss";
import "./style.scss";

const QuickReplyLabelInput = (props) => {
  const {
    value,
    languageCode,
    clientLanguageCode,
    translations,
    handleDeleteButtonLabel,
    handleUpdateButtonLabel,
    responseHandle,
    shouldShowMultipleLanguages,
    placeholder
  } = props;

  let quickReplyAction;

  // the user can only delete language labels other than their current language
  if (translations && languageCode !== clientLanguageCode) {
    quickReplyAction = (
      <Button
        customClassName="g-button m-glyph m-clear QuickReplyLabelInput__action__button"
        onClick={() => handleDeleteButtonLabel(languageCode)}
        title="Remove an Expression"
        icon="CircleRemoveAlternate"
        fillColor={colors.colorUIBad}
        clear
      />
    );
  }

  return (
    shouldShowMultipleLanguages
      ? (
        <div className="QuickReplyLabelInput">
          <div className="QuickReplyLabelInput__language-code">
            <p
              className="QuickReplyLabelInput__language-code__label"
              style={languageCode.length > 2 ? { fontSize: 8 } : {}}
            >
              {languageCode}
            </p>
          </div>
          <DebouncedInput
            id="button-label"
            placeholder={responseHandle || placeholder}
            value={value}
            onChange={label => handleUpdateButtonLabel(label, languageCode)}
            customClassName="QuickReplyLabelInput__debounced-input"
          />
          <div className="QuickReplyLabelInput__action-container">
            {quickReplyAction}
          </div>
        </div>
      ) : (
        <DebouncedInput
          id="button-label"
          placeholder={responseHandle || placeholder}
          value={value}
          onChange={label => handleUpdateButtonLabel(label, languageCode)}
        />
      )
  );
};

QuickReplyLabelInput.propTypes = {
  translations: PropTypes.bool.isRequired,
  handleUpdateButtonLabel: PropTypes.func.isRequired,
  handleDeleteButtonLabel: PropTypes.func.isRequired,
  value: PropTypes.string,
  languageCode: PropTypes.string.isRequired,
  responseHandle: PropTypes.string.isRequired,
  shouldShowMultipleLanguages: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
  clientLanguageCode: PropTypes.string.isRequired
};

QuickReplyLabelInput.defaultProps = {
  placeholder: "",
  value: ""
};

export default QuickReplyLabelInput;
